<template>
  <div class="box-style">
    <van-nav-bar placeholder title="机构详情" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
      </template>
    </van-nav-bar>

    <div>
      <van-swipe :autoplay="3000"  v-if="introduction.slideshowPic">
        <van-swipe-item v-for="(image, index) in introduction.slideshowPic.split(',')" :key="index">
          <img  :src="fileDisplayPrefix + image" />
        </van-swipe-item>
      </van-swipe>
      <div class="jj">{{introduction.introduction}}</div>
    </div>
    <div>
      <van-tabs v-model="activeName">
        <van-tab title="课程信息" name="a">
          <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">

            <!--分页列表-->
            <van-list
                class="my-list"
                v-model="data.bottomLoading"
                :finished="!data.hasMore"
                finished-text="没有更多了"
                @load="bottomRefresh()"
            >
              <div class="jg-box" v-for="(e,i) in data.records" :key="i">
                <div class="jg-list-top">
                  <img v-if="e.pic" :src="fileDisplayPrefix +  (e.pic || '').split(',')[0]"/>
                  <img v-else src="@/assets/patternless.png">
                  <div class="jg-right">
                    <h2><a href="#">{{ e.name }}</a></h2>
                    <span class="time">时间：{{ e.classTime }}</span>
                    <span>人数：{{ e.realCount }}/{{ e.planCount }}</span>
                    <span>开班日期：{{ e.startDate }}</span>
                  </div>
                </div>
                <div class="jg-bottom">
                  <b><i>￥</i>{{ e.price }}</b>
                  <van-button type="info" class="jg-but" @click="getDetailUrl(e)">报名</van-button>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>


        </van-tab>
        <van-tab title="师资信息" name="b">

          <div class="jg-box" v-for="(e,i) in teacherList" :key="i">
            <div class="jg-list-top">
              <img v-if="e.pic" :src="fileDisplayPrefix +  (e.pic || '').split(',')[0]"/>
              <img v-else src="@/assets/patternless.png">
              <div class="jg-right">
                <h2>{{ e.name }}</h2>
                <span>{{ e.teachingBranch }}</span>
                <span>{{ e.introduction }}</span>
              </div>
            </div>
          </div>

        </van-tab>
      </van-tabs>

    </div>

  </div>
</template>

<script>

import {FILE_DISPLAY_PREFIX} from "../../api/upload";
import {getInstitutionById, getTeacherList} from "../../api/organization/organization";
import {handlePageData} from "../../utils/common";
import {getCurriculumList} from "../../api/courseSelection/courseSelection";

export default {
  name: "unpaid",
  data() {
    return {
      queryParams:{},
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      },
      activeName: 'a',
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
      ],
      teacherList:[],
      introduction:{},
      id:undefined,
      loading: false,
      fileDisplayPrefix: FILE_DISPLAY_PREFIX

    }
  },
  created() {
    this.id = this.$route.query.id
    this.getById()
    this.getList()

  },
  methods: {
    getList() {
      if (this.data.loading) return
      this.data.loading = true
      this.queryParams.institutionId = this.id
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size
      getCurriculumList(this.queryParams).then(res => {
        if (res.code === 10000) {
          setTimeout(() => {
            handlePageData(this.data, res.result)
          }, 100)
        }
      }).finally(() => {
        setTimeout(() => {
          this.data.loading = false
          this.data.topLoading = false
          this.data.bottomLoading = false
        }, 100)
      })
    },

    refresh() {
      this.reset();
      this.getList();
    },
    bottomRefresh() {
      if (this.data.current > 1 && this.data.hasMore)
        this.getList()
    },
    onClickLeft() {
      this.$router.push({path: `/organization`})
    },
    getDetailUrl(e){
      if (e.realCount < e.planCount){

        this.$router.push({path: `/courseSelection/courseDetail?id=${e.id}`})
      }else {
        this.$toast("人员已满！");
      }
    },
    getById(){
      getInstitutionById({id:this.id}).then(res =>{
        if (res.code === 10000){
          this.introduction = res.result
        }
      })
      getTeacherList({id:this.id}).then(res =>{
        if (res.code === 10000){
          this.teacherList = res.result
        }
      })
    }

  }
  }


</script>

<style>
.box-style{background: #f2f6fd}
.jj{
  background: #ffffff;
  padding: 20px;
  margin-bottom: 10px;
}
.jg-box{
  background: #ffffff !important;
  border-radius: 0 !important;
  margin-bottom: 5px !important;
}
.jg-but{
  background: #66C779;
}
.jg-bottom{
  border-top: 1px solid #ededed !important;
}
.jg-but{
  background: #66C779 !important;
}
</style>
